import * as D from './Dashboard.style';
import { ChartDataType } from '@utils/types';
import { CHART_DATA, LATEST_JOINED__DATA } from '@lib/DUMMY';
import { latestJoinedTableHeader } from '@lib/data';

import { SemiBoldFont } from '@components/styled/StyledComponents';
import TableHeader from '@components/share/Table/TableHeader';
import { TableBody, EmptyTable } from '@components/share/Table/table.style';
import Main from '@components/layout/Main';
import CountBox from '@components/feature/Dashboard/CountBox';
import LineChart from '@components/feature/Dashboard/LineChart';
import StickChart from '@components/feature/Dashboard/StickChart';
import LatestJoinedTableRow from '@components/feature/Dashboard/LatestJoinedTableRow';
import Loader from '@components/share/Loader';

const Dashboard = () => {
    //TODO: 임시
    const totalLength = LATEST_JOINED__DATA.length;
    const loading = false;

    // 월간 이용자 수
    const userAmountPerMonth =
        (CHART_DATA?.userAmountPerMonth?.map((item, index) => ({
            name: `${item?.month ? item.month : index + 1}월`,
            value: item?.count || 0
        })) as ChartDataType[]) || [];
    // 월간 회원 가입자
    const newUserPerMonth = (CHART_DATA?.newUserPerMonth?.map(
        (item, index) => ({
            name: `${item?.month ? item.month : index + 1}월`,
            value: item?.count || 0
        })
    ) as ChartDataType[]) || [{ name: '1월', value: 30 }];

    if (loading) return <Loader />;

    return (
        <Main title="대시보드" fontSize={18}>
            <D.CountWrapper>
                <CountBox
                    title="월간 누적 이용자 수"
                    count={CHART_DATA?.userPerMonth || 0}
                />
                <CountBox
                    title="일일 이용자 수"
                    count={CHART_DATA?.userPerDay || 0}
                />
                <CountBox
                    title="전체 회원 가입자 수"
                    count={CHART_DATA?.totalRegisterUser || 0}
                />
                <CountBox
                    title="유료 회원 가입자 수"
                    count={CHART_DATA?.subscribedUser || 0}
                />
                <CountBox
                    title="월간 매출액"
                    count={CHART_DATA?.curMonthIncome || 0}
                />
                <CountBox
                    title="누적 매출액"
                    count={CHART_DATA?.curYearIncome || 0}
                />
            </D.CountWrapper>
            <D.ChartSection>
                <LineChart
                    title="이용자 수"
                    subTitle="월간"
                    data={userAmountPerMonth}
                />
                <LineChart
                    title="회원 가입자 수"
                    subTitle="월간"
                    data={newUserPerMonth}
                />
            </D.ChartSection>
            <D.ChartSection>
                <StickChart
                    title="이용자 수"
                    subTitle="월간"
                    data={userAmountPerMonth}
                />
                <StickChart
                    title="회원 가입자 수"
                    subTitle="월간"
                    data={newUserPerMonth}
                />
            </D.ChartSection>
            <SemiBoldFont $margin="30px 0 12px">
                최근 등록한 회원 정보
            </SemiBoldFont>
            <TableHeader header={latestJoinedTableHeader} />
            <TableBody $maxWidth={1280}>
                {totalLength === 0 ? (
                    <EmptyTable>리스트가 없습니다.</EmptyTable>
                ) : (
                    LATEST_JOINED__DATA.map((data, index) => {
                        return (
                            <LatestJoinedTableRow
                                key={`${index}-latest-joined-member`}
                                header={latestJoinedTableHeader}
                                data={data}
                            />
                        );
                    })
                )}
            </TableBody>
        </Main>
    );
};

export default Dashboard;
